import Tooltip from 'antd/lib/tooltip';
import React from 'react';
import { antGrey } from '../styles/globalStyles';
import { InfoCircleOutlined } from '@ant-design/icons';

const TooltipInfoIcon: React.FC<{ tooltipContent: React.ReactNode | string }> = ({ tooltipContent }) => {
    return (
        <Tooltip title={tooltipContent}>
            <InfoCircleOutlined style={{ color: antGrey.grey6 }} />
        </Tooltip>
    );
};

export default TooltipInfoIcon;
